/** When your routing table is too long, you can split it into small modules**/
/* Layout */
import Layout from '@/layout'

/* Router Modules */
const updateOrderRouter = {
  path: '/updateOrder',
  component: Layout,
  name: 'updateOrder',
  redirect: '/updateOrder',
  hidden: true,
  meta: {
    title: '购物车'
  },
  children: [
    {
      path: '/updateOrder',
      component: () => import('@/views/updateOrder/index'),
      name: 'updateOrder',
      meta: { title: '全部搭配', affix: true, power: true }
    }
  ]
}

export default updateOrderRouter
